import { render, staticRenderFns } from "./CurrencyExchangeBar.vue?vue&type=template&id=22405bac&scoped=true&"
import script from "./CurrencyExchangeBar.vue?vue&type=script&lang=ts&"
export * from "./CurrencyExchangeBar.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyExchangeBar.vue?vue&type=style&index=0&id=22405bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22405bac",
  null
  
)

export default component.exports